import React from "react"
import ResultTemplate from "../templates/result-template"
import Layout from "../layout"

const Result = props => {
  const count = props.resultList.filter(Boolean).length

  let award: string
  let hText: string
  let hComment: string
  let comment: string
  let umeImageSP: string
  let umeImagePC: string
  const diamond = require("../../images/award/diamond.svg")
  const gold = require("../../images/award/gold.svg")
  const silver = require("../../images/award/silver.svg")
  const bronze = require("../../images/award/bronze.svg")
  if (count <= 3) {
    //award = 'awardBronze'
    award = bronze
    hText = count + "問正解"
    hComment = "余裕と思いやりで目指せグッドマナー！"
    comment =
      "マナーというのは思いやり。自分のことだけでなく、まわりの車両のことも気づかってあげることで、気持ちのいいグッドマナーにつながります。日頃の運転でも、ちょっと意識をするだけでマナーアップできますよ！これからも安全運転でお願いします！"
    umeImageSP = "awardUmeBronzeSP"
    umeImagePC = "awardUmeBronzePC"
  }
  if (count > 3 && count <= 6) {
    //award = 'awardSilver'
    award = silver
    hText = count + "問正解"
    hComment = "気づかいのできる優しいライダー！"
    comment =
      count +
      "問正解のあなたは優しいライダー。まわりのことを考えた、マナーのある運転ができる人です。心にゆとりを持って、どんな状況でもあわてることのない、スマートな運転をこれからも心がけてください。洗練された、グッドマナーなライダーを目指しましょう！"
    umeImageSP = "awardUmeSilverSP"
    umeImagePC = "awardUmeSilverPC"
  }
  if (count > 6 && count <= 9) {
    //award = 'awardGold'
    award = gold
    hText = count + "問正解"
    hComment = "マナーのいいスマートなライダー！"
    comment = `全問正解まであと少し！${count}問正解のあなたは、グッドマナーな走りが自然にできるライダー。あなたのなにげない気づかいや思いやりが、安全で楽しいバイクライフにつながるのです！その優しさを大切に、これからも安全運転でバイクを楽しみましょう！`
    umeImageSP = "awardUmeGoldSP"
    umeImagePC = "awardUmeGoldPC"
  }
  if (count === 10) {
    //award = 'awardDiamond'
    award = diamond
    hText = "全問正解"
    hComment = "グッドマナーの素敵なライダー！"
    comment =
      "全問正解のあなたは、グッドマナーが身についている素敵なライダー！あなたの余裕ある、スマートな運転が、バイクを「カッコいい、素敵な乗り物」へとイメージアップしてくれるのです！これからも、ライダーのお手本として、カッコいいライダーとして、バイクをスマートに楽しんでくださいね！"
    umeImageSP = "awardUmeDiamondSP"
    umeImagePC = "awardUmeDiamondPC"
  }

  const Props = {
    index: props.index,
    resultList: props.resultList,
    toIndex: props.toIndex,
    award: award,
    imageNameSP: umeImageSP,
    imageNamePC: umeImagePC,
    hText: hText,
    hComment: hComment,
    comment: comment,
  }
  return (
    <Layout>
      <ResultTemplate {...Props} />
    </Layout>
  )
}

export default Result
